// extracted by mini-css-extract-plugin
export default {"left":"ComingSoon_left__yzrg2","ico":"ComingSoon_ico__ljOnR","text":"ComingSoon_text__h0GHc","link":"ComingSoon_link__dMObY","dark":"ComingSoon_dark__TVQsy"};